export interface CarvetConfig {
  showMileage: boolean;
  showOrigin: boolean;
  showStockCount: boolean;
  showManufacturer: boolean;
  showTargetEngine: boolean;
  showKppAliases: boolean;
  showDriveType: boolean;
  showSpecsVolumeFuel: boolean;
  showSpecsPower: boolean;
  btnTextEngine: string;
  btnTextKpp: string;
}

export const carvetConfig: CarvetConfig = {
  showMileage: true,
  showOrigin: true,
  showStockCount: true,
  showManufacturer: false,
  showTargetEngine: true,
  showKppAliases: true,
  showDriveType: true,
  showSpecsVolumeFuel: true,
  showSpecsPower: true,
  btnTextEngine: "Оформить заявку на двигатель",
  btnTextKpp: "Оформить заявку на КПП",
};

export const BRANDS = [
  "Hyundai",
  "Kia",
  "SsangYong",
  "BMW",
  "Volkswagen",
  "Audi",
  "Skoda",
  "Mitsubishi",
  "Nissan",
  "Chevrolet",
  "Daewoo",
  "Peugeot",
  "Citroen",
] as const;

export type CategorySlug = "all" | "dvs" | "kpp";

export interface CatalogItem {
  id: string;
  category: string;
  categorySlug: CategorySlug | string;
  brand: string;
  brandRu?: string;
  baseModel?: string;
  model: string;
  modelRu?: string;
  year: string;
  fuel: string;
  displacement: string;
  power: string;
  engineCode: string;
  transmissionType?: string;
  transmissionCode?: string;
  driveType?: string;
  oem?: string;
  donorVin?: string;
  origin?: string;
  mileage?: string;
  warrantyDays?: number;
  priceEst?: string;
  stockStatus?: string;
  inStockCount?: number;
  compression?: string;
  hasAttachments?: string;
  features?: string;
  manufacturer?: string;
  targetEngineCode?: string;
  kppAliases?: string;
}

export interface RawDvsItem {
  categorySlug?: string;
  brand: string;
  brandRu?: string;
  baseModel: string;
  modelRu?: string;
  generation?: string;
  yearFrom: number;
  yearTo?: number;
  engineType?: string;
  volume?: number;
  power?: string;
  engineCode?: string;
  modification?: string;
}

export interface SelectedFilters {
  brand: string;
  model: string;
  fuel: string;
  displacement: string;
  power: string;
  searchQuery: string;
}

export interface LeadFormData {
  name: string;
  phone: string;
  item: CatalogItem | null;
  additionalNotes: string;
}

export interface LeadResponse {
  success: boolean;
  leadId?: number;
  message?: string;
  error?: string;
  isNetworkOrCors?: boolean;
}

export interface SearchSuggestion {
  type: "code" | "model";
  value: string;
  label: string;
  brand?: string;
  model?: string;
  categorySlug?: string;
}

export type ModalMode = "lead" | "photo" | "callback";
